import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollDefinitionService } from 'app/core/services/payroll-definition.service';
import { RefreshPeriodService } from 'app/core/services/refresh-period.service';
import { RefreshService } from 'app/core/services/refresh.service';

@Component({
  selector: 'dialog-delete-concept',
  templateUrl: './dialog-delete-concept.component.html',
  styleUrls: ['./dialog-delete-concept.component.scss']
})
export class DialogDeleteConceptComponent implements OnInit {
  isLoading: boolean = false;
  
  constructor(public dialogRef: MatDialogRef<DialogDeleteConceptComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
              private payrollDefinitionService: PayrollDefinitionService,
              private refreshService: RefreshService,
              private refreshPeriodService: RefreshPeriodService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteConcept() {
    this.isLoading = true;
    this.payrollDefinitionService.deleteConcept(this.data.id).subscribe({
      next: res => {
        this.isLoading = false;
        this.dialogRef.close();
        window.location.reload();
      },
      error: err => {
        this.isLoading = false;
        console.log(err);
      }
    });
  }

  deleteSelectedConcept() {
    this.isLoading = true;
    this.payrollDefinitionService.deleteConcept(this.data.selectedIds).subscribe({
      next: (res) => {
        this.refreshPeriodService.emitRefresh(this.data.selectedIds);
        Promise.resolve().then(() => {
          this.isLoading = false;
          this.dialogRef.close();
        });
      },
      error: (err) => {
        this.isLoading = true;
        console.error('Error deleting concepts:', err);
        alert('Failed to delete selected concepts.');
      },
    });
  }
}
